import { Expose, Type } from 'class-transformer';

import { ProductOptionModel } from '@/entities/product/model';

export class OrderItemModel {
  @Expose()
  id: number;

  @Expose({ name: 'product_options' })
  @Type(() => ProductOptionModel)
  productOptions?: ProductOptionModel[] | null;

  @Expose()
  quantity: number;

  @Expose()
  price: number;

  @Expose()
  order: number;

  @Expose()
  product: number;
}